import React from "react";
import { Button, withStyles } from "@material-ui/core";
import COLORS from "../../assets/Colors";
import theme from "../../assets/theme";

/*

const PrimaryBtnStyle = {
  root: {
    backgroundColor: COLORS.BTN_GREEN,
    color: COLORS.PRIMARY_WHITE,
    fontFamily: theme.fonts.primaryFontBold,
    fontSize: 16,
    width: "100%",
    textTransform: "none",
    borderRadius: 60,
    padding: "16px 22px",
    border: `1px solid ${COLORS.BTN_GREEN}`,
    transition: "300ms",

    "& .arrow-icon": {
      display: "inline-block",
      width: "20px",
      height: "20px",
      marginLeft: "8px",
      backgroundImage: `url(${UpArrowRight})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      transition: "background-image 0.3s ease",
    },

    "&:hover": {
      background: COLORS.BTN_GREEN,
      backgroundColor: COLORS.BTN_GREEN,

      // Hover state - shows ArrowRight
      "& .arrow-icon": {
        // width: "18px",
        // height: "20px",
        marginLeft: "8px",
        backgroundImage: `url(${ArrowRight})`,
      },
    },
    "&:active": {
      backgroundColor: COLORS.BTN_GREEN,
      borderColor: COLORS.BTN_GREEN,
    },
    "&:focus": {
      borderColor: COLORS.BTN_GREEN,
    },
  },
  label: {
    lineHeight: 1,
  },
  disabled: {
    borderColor: "rgba(0, 0, 0, 0.26)",
    opacity: 0.6,
    color: `${COLORS.PRIMARY_WHITE} !important`,
  },
};

*/

const PrimaryBtnStyle = {
  root: {
    backgroundColor: COLORS.BTN_GREEN,
    color: COLORS.PRIMARY_WHITE,
    fontFamily: theme.fonts.primaryFontBold,
    fontSize: 16,
    width: "100%",
    textTransform: "none",
    borderRadius: 60,
    padding: "16px 22px",
    border: `1px solid ${COLORS.BTN_GREEN}`,
    transition: "all 300ms ease",

    "& .arrow-icon": {
      display: "none",
    },

    "@media (hover: hover) and (pointer: fine)": {
      "&:hover": {
        backgroundColor: COLORS.PRIMARY_WHITE,
        color: COLORS.BTN_GREEN,
        borderColor: COLORS.BTN_GREEN,
      },
    },
    
    "&:active": {
      backgroundColor: COLORS.PRIMARY_WHITE,
      color: COLORS.BTN_GREEN,
      borderColor: COLORS.BTN_GREEN,
    },

    "&:focus": {
      backgroundColor: COLORS.BTN_GREEN,
      color: COLORS.PRIMARY_WHITE,
    },

    "&:focus-visible": {
      outline: `2px solid ${COLORS.PRIMARY_WHITE}`,
      outlineOffset: 3,
    },
  },

  label: {
    lineHeight: 1,
  },

  disabled: {
    borderColor: "rgba(0, 0, 0, 0.26)",
    opacity: 0.6,
    color: `${COLORS.PRIMARY_WHITE} !important`,
  },
};

const OutlinedPrimaryBtnStyle = {
  root: {
    backgroundColor: COLORS.PRIMARY_WHITE,
    color: "#293462",
    fontFamily: theme.fonts.primaryFontBold,
    fontSize: 16,
    width: "100%",
    textTransform: "none",
    borderRadius: 60,
    padding: "16px 22px",
    border: `1px solid #293462`,
    "&:hover": {
      backgroundColor: "#293462",
      borderColor: "#293462",
      color: "#ffffff",
    },
    "&:active": {
      backgroundColor: COLORS.PRIMARY_WHITE,
      borderColor: "#ffffff",
    },
    "&:focus": {
      borderColor: COLORS.BTN_GREEN,
    },
  },
  label: {
    lineHeight: 1,
  },
  disabled: {
    borderColor: "rgba(0, 0, 0, 0.26)",
    opacity: 0.6,
  },
};

const PrimaryButtonWithBackgroundImage = withStyles(PrimaryBtnStyle)(Button);

// Usage Examples
export const PrimaryCTAButton = ({ children, ...props }) => (
  <PrimaryButtonWithBackgroundImage {...props}>
    {children}
    <span className="arrow-icon" />
  </PrimaryButtonWithBackgroundImage>
);

export const PrimaryOutlinedCTAButton = withStyles(OutlinedPrimaryBtnStyle)(
  Button
);
